import { render, staticRenderFns } from "./XiuxianActivity.vue?vue&type=template&id=0ba5bf2a&scoped=true"
import script from "./XiuxianActivity.vue?vue&type=script&lang=js"
export * from "./XiuxianActivity.vue?vue&type=script&lang=js"
import style0 from "./XiuxianActivity.vue?vue&type=style&index=0&id=0ba5bf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba5bf2a",
  null
  
)

export default component.exports